import { plainToClass } from "class-transformer";
import { DeliverableListingDto } from "./deliverables.objects";
import { TableColumnVisibilityController, TableColumnGroup } from "../../../shared/scripts/table-column-visibility";
import { Unique } from "../../../shared/scripts/array-functions";
import { IFilter } from "../../../shared/scripts/filtering/filtering.entities";
import { InitializeFilterDropdown, InitializeDateSelector, GetSelectedDate } from "../../../shared/scripts/filtering/filtering.utilities";
import { DeliverableDialog } from "../sites/scripts/site-deliverable.dialog";
import { AuditHistoryDialog } from "../audit/scripts/audit-history.dialog";
import { getData } from "../sites/scripts/site.utilities";

export class DeliverablesPage implements IFilter {
    deliverables: DeliverableListingDto[];
    dataTable: any;
    filterDropdownIds: string[];
    eventDatePickerId: string = '#event-date-field';
    expectedDueDatePickerId: string = '#expected-due-date-field';
    completionDatePickerId: string = '#completion-date-field';

    deliverableDialog: DeliverableDialog;

    isNonViewer: boolean;

    constructor(allDeliverablesJson: any, isNonViewer: boolean) {
        $(() => {
            this.isNonViewer = isNonViewer === true;
            this.deliverables = plainToClass(DeliverableListingDto, <DeliverableListingDto[]>allDeliverablesJson);
            this.filterDropdownIds = [
                '#site-dropdown',
                '#deliverable-dropdown',
                '#status-dropdown',
            ];
            this.initializeFilters();
            this.initializeTable();
            this.initializeDialog();
        });
    }

    initializeFilters(): void {
        // Site filter
        let siteValues: string[] = this.deliverables.map(d => d.SiteName);
        InitializeFilterDropdown('#site-dropdown', Unique(siteValues, true, ["None Selected"]), this);
        // Deliverable Filter
        let deliverableValues: string[] = this.deliverables.map(d => d.DeliverableName);
        InitializeFilterDropdown('#deliverable-dropdown', Unique(deliverableValues, true, ["None Selected"]), this);
        // Status filter
        let statusValues: string[] = this.deliverables.map(d => d.StatusName);
        InitializeFilterDropdown('#status-dropdown', Unique(statusValues, true, ["None Selected"]), this);
        // Expected Due Date filter
        //InitializeDateSelector('expected-due-date-field', this);
        // Completion Date filter
        //    InitializeDateSelector('completion-date-field', this);
        $(this.eventDatePickerId + ',' + this.expectedDueDatePickerId + ',' + this.completionDatePickerId).on('change input', () => {
            this.triggerFilter();
        });
    }

    initializeTable(): void {
        this.dataTable = $('#deliverables-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[4, 'asc']], // Order by Expected Due Date
            columns: [
                { data: "SiteNumber", title: "Site Number" },
                { data: "SiteName", title: "Site Name" },
                { data: "DeliverableName", title: "Deliverable" },
                { data: "EventDate", title: "Event Date" },
                { data: "ExpectedDueDate", title: "Expected Due Date" },
                { data: 'CompletionDate', title: 'Completion Date', className: '' },
                { data: "StatusName", title: "Status" },
                {
                    data: null,
                    title: "",
                    className: "ctms-table-col-actions",
                    orderable: false,
                    render: function () {
                        return '<button><i class="ctms-icon-pencil"></i></button>';
                    }
                }
            ],
            data: this.deliverables
        });

        $('#custom-dt-search').on('input', function () {
            $('#deliverables-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('.ctms-icon-button[title="Clear Search"]').on('click', function () {
            $('#custom-dt-search').val('');
            $('#deliverables-table').DataTable().search('').draw();
        });
    }

    async initializeDialog() {
        const deliverableRefData = await getData(`/secure/ctms/sites/site-details?handler=DeliverableStatusList`);
        const auditDialog = new AuditHistoryDialog();
        this.deliverableDialog = new DeliverableDialog(deliverableRefData, !this.isNonViewer, auditDialog);
        this.deliverableDialog.successCallback = this.deliverableDialogSuccess.bind(this);


        $(document).on('click', '#deliverables-table .ctms-table-col-actions .ctms-icon-pencil', async (evt) => {
            const row = $(evt.target).closest('tr');
            const d = $('#deliverables-table').DataTable().row(row).data();

            this.deliverableDialog.resetDialog(d);
            $('#editDeliverableDialog').modal('show');
        });
    }

    updateTable(matchingItems: DeliverableListingDto[]): void {
        this.dataTable.clear();
        this.dataTable.rows.add(matchingItems).draw();
    }

    triggerFilter(): void {
        const selectedSite = this.getSelectedDropdownValues('#site-dropdown');
        const selectedDeliverable = this.getSelectedDropdownValues('#deliverable-dropdown');
        const selectedStatus = this.getSelectedDropdownValues('#status-dropdown');
        // Get date from datepicker as yyyy-MM-dd
        //const expectedDueDateObj = GetSelectedDate(this.expectedDueDatePickerId);
        //let selectedExpectedDueDate = "";
        //if (expectedDueDateObj) {
        //    const yyyy = expectedDueDateObj.getFullYear();
        //    const mm = String(expectedDueDateObj.getMonth() + 1).padStart(2, '0');
        //    const dd = String(expectedDueDateObj.getDate()).padStart(2, '0');
        //    selectedExpectedDueDate = `${yyyy}-${mm}-${dd}`;
        //}
        //const completionDateObj = GetSelectedDate(this.completionDatePickerId);
        //let selectedCompletionDate = "";
        //if (completionDateObj) {
        //    const yyyy = completionDateObj.getFullYear();
        //    const mm = String(completionDateObj.getMonth() + 1).padStart(2, '0');
        //    const dd = String(completionDateObj.getDate()).padStart(2, '0');
        //    selectedCompletionDate = `${yyyy}-${mm}-${dd}`;
        //}
        let eventDateObj = $(this.eventDatePickerId).val();
        let selectedEventDate = "";

        if (Array.isArray(eventDateObj)) {
            selectedEventDate = eventDateObj.length > 0 ? String(eventDateObj[0]) : "";
        } else {
            selectedEventDate = String(eventDateObj);
        }

        let expectedDueDateObj = $(this.expectedDueDatePickerId).val();
        let selectedExpectedDueDate = "";
        if (Array.isArray(expectedDueDateObj)) {
            selectedExpectedDueDate = expectedDueDateObj.length > 0 ? String(expectedDueDateObj[0]) : "";
        } else {
            selectedExpectedDueDate = String(expectedDueDateObj);
        }
        let completionDateObj = $(this.completionDatePickerId).val();
        let selectedCompletionDate = "";
        if (Array.isArray(completionDateObj)) {
            selectedCompletionDate = completionDateObj.length > 0 ? String(completionDateObj[0]) : "";
        } else {
            selectedCompletionDate = String(completionDateObj);
        }

        const matchingDeliverables: DeliverableListingDto[] = [];
        this.deliverables.forEach(item => {
            if (item.matchesFilter(
                selectedSite,
                selectedDeliverable,
                selectedStatus,
                selectedEventDate,
                selectedExpectedDueDate,
                selectedCompletionDate
            )) {
                matchingDeliverables.push(item);
            }
        });
        this.updateTable(matchingDeliverables);
    }

    getSelectedDropdownValues(selectId: string): any {
        return $(selectId).val();
    }

    resetFilters(): void {
        this.filterDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('selectAll');
            $(dropdownId).selectpicker('refresh');
        });
        $(this.expectedDueDatePickerId).datepicker('update', '');
        $(this.completionDatePickerId).datepicker('update', '');
        $('#custom-dt-search').val('');
        this.dataTable.search('').draw();
        this.updateTable(this.deliverables);
    }

    deliverableDialogSuccess(response) {
        const r = plainToClass(DeliverableListingDto, response);
        this.deliverables = this.deliverables.map(d => (d.Id === r.Id) ? r : d);
        this.resetFilters();
    }
}